<script>
import Layout from '@layouts/main'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mask } from 'vue-the-mask'
import moment from 'moment'
moment.locale('pt-br')

/**
 * Register Prospect Component
 */
export default {
  components: {
    Layout,
    Loading,
  },
  directives: { mask },
  props: {
    semestre: '',
    data: '',  
    estoques: [],
  },
  data() {
    return {
      isLoading: false,
      prospect: {},
      fields: [
        {
          key: 'nome',
          label: 'Produto',
        },
        {
          key: 'quantidade',
          label: 'Estoque',
        },
        {
          key: 'data',
          label: 'Aquisição',
        },
        {
          key: 'data',
          label: 'Venda',
        },
        {
          key: 'disponivel',
          label: 'Estoque atual',
        },
      ],
    }
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    formatDate(date) {
      if (date != undefined) return moment.utc(date).format('DD/MM/YYYY')

      return '-'
    },
    formatYear(date) {
      if (date != undefined) return moment.utc(date).format('YYYY')

      return '-'
    },
  },
}
</script>
<template>
  <div>
    <div class="row">
      <div class="col-md-12 d-flex justify-content-end">
        <h4>CONTROLE DE VENDAS E ESTOQUE</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <span><b>Empresa: </b>{{ estoques[0].empresa }}</span>
      </div>
      <div class="col-md-12">
        <span><b>Endereço: </b>{{ estoques[0].endereco }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <span><b>Cidade: </b>{{ estoques[0].cidade }}</span>
      </div>
      <div class="col-md-6">
        <span><b>Estado: </b>{{ estoques[0].estado }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <span><b>Semestre: </b>{{ semestre }}º semestre</span>
      </div>
      <div class="col-md-4">
        <span><b>Data: </b>{{ formatDate(data) }}</span>
      </div>
      <div class="col-md-4">
        <span><b>Ano: </b>{{ formatYear(data) }}</span>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-12">
        <b-table
          striped
          hover
          responsive="sm"
          borderless
          bordered
          outlined
          small
          :items="estoques"
          :fields="fields"
        >
          <template v-slot:cell(data)="row">
            {{ formatDate(row.item.data) }}
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
</style>